/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Release_Dialog_DateInputs */



/**
* | output |
* | --- |
* | "Released on {date}" |
*
* @param {Release_Dialog_DateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const release_dialog_date = /** @type {((inputs: Release_Dialog_DateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Dialog_DateInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Veröffentlicht am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Released on ${i?.date}`)
});